export class Createproject {
    projectid: string;
    projectname: string;
    clientname: string;
    country: string;
    language: string;
    quotatarget: number;
    optimisticcount: number;
    projectdescription: string;
    ipsecurity:boolean;
    geoiplocation:boolean;
    custompage:boolean;
    fingerprintsecurity:boolean;
    recaptcha:boolean;
    invisiblerecaptcha :boolean;
    questionnaire:boolean;
    mobile:number;
    countryid: number;
    languageid: number;
    waitingTime : number;
    teamMember: string[];
    selectedFromHour: number 
    selectedFromMinute: string;
    selectedFromAmpm: string;
    selectedToHour: number;
    selectedToMinute: string;
    selectedToAmpm: string;
    isActiveLocalTimeZone :boolean;
    proposalCode:string;
}
